import { useQuery } from "@tanstack/react-query";
import { contributionsApi } from "@/api/contributions.api";
import paymentsApi from "@/api/payments.api";

/** The contributor's own figures and payout situation, both computed by the server. */
export function useContributorHome(userId: string | undefined) {
  const stats = useQuery({
    queryKey: ["contributor-home", "stats", userId],
    queryFn: () => contributionsApi.getUserStats(userId!),
    enabled: Boolean(userId),
  });
  const situation = useQuery({
    queryKey: ["contributor-home", "payout-situation", userId],
    queryFn: () => paymentsApi.getContributorPayoutSituation(Number(userId)),
    enabled: Boolean(userId),
    // A contributor without payout data yet still gets the page.
    retry: false,
  });
  // The stats endpoint carries no daily series for one contributor: the week
  // is counted from the contribution history of the last seven days.
  const since = new Date();
  since.setHours(0, 0, 0, 0);
  since.setDate(since.getDate() - 6);
  const sinceIso = since.toISOString().slice(0, 10);
  const history = useQuery({
    queryKey: ["contributor-home", "week", userId, sinceIso],
    queryFn: () => contributionsApi.getUserHistory(userId!, { dateDebut: sinceIso, limit: 500 }),
    enabled: Boolean(userId),
  });
  return { stats, situation, history };
}
